/* unplugin-vue-components disabled */import { render } from "./SelectFavorite.vue?vue&type=template&id=dd0b695e&scoped=true"
import script from "./SelectFavorite.vue?vue&type=script&lang=js"
export * from "./SelectFavorite.vue?vue&type=script&lang=js"

import "./SelectFavorite.vue?vue&type=style&index=0&id=dd0b695e&lang=css"
import "./SelectFavorite.vue?vue&type=style&index=1&id=dd0b695e&lang=scss&scoped=true"

import exportComponent from "/Users/shinone/workingspace/xw/xwtec-assets-client/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.24_vue@3.5.24_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd0b695e"]])

export default __exports__